export default __webpack_public_path__ + "static/media/Goz_Attila_CV.cc9209ee.pdf";